export default __webpack_public_path__ + "static/media/uploadBlack.5e689932.svg";